// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { ProviderServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Provider';
import { CreateEvent } from '@daml/ledger';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRequestProviderService: () => UseMutationResult<
  CreateEvent<ProviderServiceRequest>,
  string,
  void
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();

  return useMutation({
    mutationKey: ['requestRegistryProviderService', ledgerApi, operator, party],
    mutationFn: async () => {
      return ledgerApi.requestRegistryProviderService(operator, party);
    },
  });
};

export default useRequestProviderService;
